<template>
  <div
    class="flex flex-wrap items-center justify-center min-h-screen overflow-x-hidden overflow-y-auto p-4"
    :class="$style['registration']">
    <XConfirmInvitationForm />
  </div>
</template>

<script>
import XConfirmInvitationForm from '@plat/views/partials/forms/ConfirmInvitationForm'

export default {
  components: {
    XConfirmInvitationForm
  }
}
</script>

<style lang="scss" module>
.registration {
  background: url('../../assets/images/login-sign-up.jpg') no-repeat fixed center;
  background-size: cover;
}
</style>
